<template>
  <b-card header="Opciones de Filtro" class="card-filter">
    <b-btn class="filter-collapse" variant="primary" @click.prevent="showOpciones = !showOpciones">
      <i :class="showOpciones ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
    </b-btn>
    <b-collapse id="filtro" class="mt-2" v-model="showOpciones">
      <b-form>
        <b-form-group label="Desde" label-for="fechaDesde" :label-cols="2" horizontal>
          <b-form-input id="fechaDesde" v-model="filtro.fechaDesde" type="date"> </b-form-input>
        </b-form-group>

        <b-form-group label="Hasta" label-for="fechaHasta" :label-cols="2" horizontal>
          <b-form-input id="fechaHasta" v-model="filtro.fechaHasta" type="date"> </b-form-input>
        </b-form-group>

        <app-clientes
          label="Cliente"
          labelTodos="Todos los clientes"
          :horizontal="Boolean(true)"
          :nullDisabled="Boolean(false)"
          :labelCols="2"
          :nombre="filtro.clienteNombre"
          :lista="clientesList"
          @updated="clienteActualizado">
        </app-clientes>

        <app-retenciones-tipos
          label="Tipo"
          labelTodos="Todos los tipos"
          :horizontal="Boolean(true)"
          :nullDisabled="Boolean(false)"
          :labelCols="2"
          :nombre="filtro.retencionTipoNombre"
          :lista="retencionesTiposList"
          @updated="retencionTipoActualizado">
        </app-retenciones-tipos>

        <app-retenciones-regimenes
          label="Regimen"
          labelTodos="Todos los regimenes"
          :horizontal="Boolean(true)"
          :nullDisabled="Boolean(false)"
          :labelCols="2"
          :nombre="filtro.retencionRegimenNombre"
          :lista="retencionesRegimenesList"
          @updated="retencionRegimenActualizado">
        </app-retenciones-regimenes>

        <!--
        <b-form-group
          label-for="incluirRetencionesLiquidadas"
          :label-cols="2">
          <b-form-checkbox
              id="incluirRetencionesLiquidadas"
              v-model= "filtro.incluirRetencionesLiquidadas"
              value= true
              unchecked-value= false>
              Incluir Retenciones Liquidadas
          </b-form-checkbox>
        </b-form-group>
        -->

        <div slot="footer">
          <b-button size="sm" variant="primary" class="footer-button" @click.prevent="filtrar">Filtrar</b-button>
        </div>
      </b-form>
    </b-collapse>

    <app-mensaje :modalMsj="modalMsj" :modalMensaje="modalMensaje" @okAction="okAction" @hiddenAction="hiddenAction" />
  </b-card>
</template>

<script>
import Clientes from '../shared/abmSelect.vue'
import RetencionesTipos from '../shared/abmSelect.vue'
import RetencionesRegimenes from '../shared/abmSelect.vue'
import Mensaje from '../shared/msjModal.vue'
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment'

export default {
  props: {
    fechaDesde: {
      type: String,
      default: '',
    },
    fechaHasta: {
      type: String,
      default: '',
    },
    cliente: {
      type: Object,
      default: null,
    },
    proveedor: {
      type: Object,
      default: null,
    },
    retencionTipo: {
      type: Object,
      default: null,
    },
    retencionRegimen: {
      type: Object,
      default: null,
    },
    /*
    incluirRetencionesLiquidadas: {
      type: Boolean,
      default: false
    },
    */
  },
  components: {
    appClientes: Clientes,
    appRetencionesTipos: RetencionesTipos,
    appRetencionesRegimenes: RetencionesRegimenes,
    appMensaje: Mensaje,
  },
  mixins: [msjModal],
  data() {
    return {
      filtro: {
        fechaDesde: '',
        fechaHasta: '',
        cliente: null,
        clienteNombre: '',
        proveedor: null,
        proveedorNombre: '',
        retencionTipo: null,
        retencionTipoNombre: '',
        retencionRegimen: null,
        retencionRegimenNombre: '',
        incluirRetencionesLiquidadas: false,
      },

      clientes: [],
      clientesList: [],
      retencionesTipos: [],
      retencionesTiposList: [],
      retencionesRegimenes: [],
      retencionesRegimenesList: [],

      showOpciones: Boolean(false),
    }
  },
  created() {
    this.filtro.fechaDesde = moment.utc(this.fechaDesde).format('YYYY-MM-DD')
    this.filtro.fechaHasta = moment.utc(this.fechaHasta).format('YYYY-MM-DD')
    this.filtro.cliente = this.cliente
    this.filtro.clienteNombre = this.cliente ? this.cliente.nombre : null
    this.filtro.proveedor = this.proveedor
    this.filtro.proveedorNombre = this.proveedor ? this.proveedor.nombre : null
    this.filtro.retencionTipo = this.retencionTipo
    this.filtro.retencionTipoNombre = this.retencionTipo ? this.retencionTipo.nombre : null
    this.filtro.retencionRegimen = this.retencionRegimen
    this.filtro.retencionRegimenNombre = this.retencionRegimen ? this.retencionRegimen.nombre : null
    this.filtro.incluirRetencionesLiquidadas = this.incluirRetencionesLiquidadas

    this.getDatosAdicionales()
  },
  computed: {},
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro)
    },
    getDatosAdicionales() {
      const vm = this

      this.$store
        .dispatch('clientes/getList', Boolean(false))
        .then(() => {
          vm.clientes = this.$store.getters['clientes/list']
          vm.clientesList = this.$store.getters['clientes/selectList']
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de clientes'))

      this.$store
        .dispatch('retencionestipos/getList')
        .then(() => {
          vm.retencionesTipos = this.$store.getters['retencionestipos/list']
          vm.retencionesTiposList = this.$store.getters['retencionestipos/selectList']

          vm.retencionesRegimenes = []
          vm.retencionesRegimenesList = []
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de retenciones'))
    },
    getRegimenes() {
      this.filtro.retencionRegimenNombre = null
      this.retencionesRegimenes = []
      this.retencionesRegimenesList = []

      let retencionTipo = null
      if (this.filtro.retencionTipoNombre) {
        retencionTipo = this.getSelected(this.retencionesTipos, this.filtro.retencionTipoNombre)
      }

      if (retencionTipo) {
        if (retencionTipo.id != 0) {
          this.$store
            .dispatch('retencionesregimenes/getList', retencionTipo.id)
            .then(() => {
              this.retencionesRegimenes = this.$store.getters['retencionesregimenes/list']
              this.retencionesRegimenesList = this.$store.getters['retencionesregimenes/selectList']
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de regimenes de retencion'))
        }
      }
    },
    clienteActualizado(nombre) {
      this.filtro.clienteNombre = nombre
      this.filtro.cliente = this.getSelected(this.clientes, nombre)
    },
    retencionTipoActualizado(nombre) {
      this.filtro.retencionTipoNombre = nombre
      this.filtro.retencionTipo = this.getSelected(this.retencionesTipos, nombre)

      this.getRegimenes()
    },
    retencionRegimenActualizado(nombre) {
      this.filtro.retencionRegimenNombre = nombre
      this.filtro.retencionRegimen = this.getSelected(this.retencionesRegimenes, nombre)
    },
  },
}
</script>

<style></style>
